export const DEFAULT_TRANSITION_TIME_IN_MS = 200;
export const DEFAULT_TRANSITION_TIME = `${DEFAULT_TRANSITION_TIME_IN_MS}ms`;
